if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.disclosure = this.closest('details');
      this.cartNoteToggle = this.disclosure?.querySelector('.js-show-note');

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      this.addEventListener('keyup', this.debouncedHandleNoteChange);
      this.addEventListener('change', this.debouncedHandleNoteChange);

      // Handle GST Number and Business Name changes
      document.getElementById('gst-number')?.addEventListener('change', this.handleAttributeChange.bind(this));
      document.getElementById('business-name')?.addEventListener('change', this.handleAttributeChange.bind(this));
    }

    handleNoteChange(evt) {
      const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
      if (this.cartNoteToggle) this.cartNoteToggle.textContent = label;

      fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: evt.target.value })
      });
    }

    handleAttributeChange(evt) {
      const attributes = {
        gstin_number: document.getElementById('gst-number').value || '',
        company_name: document.getElementById('business-name').value || ''
      };

      fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes })
      })
      .then(response => response.json())
      .then(data => console.log('Cart updated with attributes:', data))
      .catch(error => console.error('Error updating attributes:', error));
    }
  }

  customElements.define('cart-note', CartNote);
}
